<div class="textbox-container">
  <app-base-label
    *ngIf="!!label"
    [required]="checkRequiredField()"
    [label]="label"
    [labelOneLine]="labelOneLine"
    [iconLabelTooltip]="iconLabelTooltip"
    [currency]="currency"
  >
  </app-base-label>
  <div class="input-container" *ngIf="mode === 'text' || mode === 'password'">
    <input
      pInputText
      [type]="mode"
      placeholder="{{ placeholder | translate }}"
      [ngClass]="{
        invalid: checkInvalidField(),
        'pr-30': !!iconUrl,
        'pl-30': !!leftIconUrl,
        disabled: disabled
      }"
      [readonly]="disabled"
      [formControl]="fieldControl"
      (blur)="onBlur()"
      [onlyNumber]="onlyNumber"
      [maxLength]="maxLength"
    />

    <img *ngIf="!!iconUrl" [src]="iconUrl" />
    <img class="leftIcon" *ngIf="!!leftIconUrl" [src]="leftIconUrl" />
    <div class="prefix" *ngIf="!!prefix">{{ prefix }}</div>
    <div class="description-message" *ngIf="descriptionMessage">
      {{ descriptionMessage | translate }}
    </div>
  </div>
  <div class="input-switch-container" *ngIf="mode === 'switch'">
    <p-inputSwitch [formControl]="fieldControl"></p-inputSwitch>
    <div class="inline-flex ml-2">{{ content | translate }}</div>
  </div>
  <div class="input-number-container" *ngIf="mode === 'contact'">
    <input
      pInputText
      placeholder="{{ placeholder | translate }}"
      [ngClass]="{
        invalid: checkInvalidField(),
        disabled: disabled
      }"
      [readonly]="disabled"
      [formControl]="fieldControl"
      (blur)="onBlur()"
      [onlyNumberSpaceAndDash]="true"
      [maxLength]="maxLength"
    />
  </div>
  <div class="input-number-container" *ngIf="mode === 'number'">
    <p-inputNumber
      [readonly]="disabled"
      [formControl]="fieldControl"
      (blur)="onBlur()"
      [maxlength]="maxLength"
      placeholder="{{ placeholder | translate }}"
      [ngClass]="{
        invalid: checkInvalidField(),
        'pr-30': !!iconUrl,
        'pl-30': !!leftIconUrl || !!prefix,
        disabled: disabled
      }"
      [inputStyle]="{ 'padding-left': paddingForPrefix + 'px' }"
      [minFractionDigits]="minFractionDigits"
      [maxFractionDigits]="maxFractionDigits"
      [useGrouping]="useGrouping"
      mode="decimal"
      [allowEmpty]="true"
      [min]="min"
      [max]="max"
    ></p-inputNumber>

    <img *ngIf="!!iconUrl" [src]="iconUrl" />
    <img class="leftIcon" *ngIf="!!leftIconUrl" [src]="leftIconUrl" />
    <div #prefix_content class="prefix" *ngIf="!!prefix">{{ prefix }}</div>
    <div *ngIf="suffix" class="suffix">{{ suffix }}</div>
  </div>
  <div class="input-number-container" *ngIf="mode === 'label-text'">
    <app-base-label
      [currency]="currency"
      [labelStyle]="'font-normal ' + labelTextStyle"
      [label]="fieldControl?.value"
    >
    </app-base-label>
  </div>
  <app-base-label
    ngClass="mt-2"
    *ngIf="checkInvalidField()"
    [label]="errorMessage"
    mode="error"
  >
  </app-base-label>
</div>
